import React, { useContext, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { List } from './List';
import { AuthContext } from 'contexts/AuthContext';
import { getDomains } from "utils/api";

export const AdminDomains = () => {
    const { handleError } = useContext(AuthContext);

    const [domains, setDomains] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchDomains = async () => {
        setIsLoading(true);

        try {
            const res = await getDomains();

            res?.domains && setDomains(res.domains);
        } catch (err) {
            handleError(err);
        }

        setIsLoading(false);
    };

    const refreshDomains = async (callback) => {
        await fetchDomains();
        callback && callback();
    };

    useEffect(() => {
        fetchDomains();
    }, []);

    return (
        <div className="view view--mobile-full">
            <div className="animated fadeIn">
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardHeader>
                                <div className="flex-space-between">
                                    <h1>Domains</h1>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <List domains={domains} isLoading={isLoading} refreshDomains={refreshDomains}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
